<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"test.typelbl" | translate}}</h5>
</div>
<div class="vetro-bg">
    <div class="p-field form-group">
        <div class="row">
            <div class="col-md-1">
                <label for="name" class="col-form-label">Name</label>
            </div>
            <div class="col-md-3 mb-4">
                <input type="text" pInputText id="name" [(ngModel)]="model.name" required />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="orderId" class="col-form-label">Order Id</label>
            </div>
            <div class="col-md-3 mb-4">
                <input type="text" pInputText id="orderId" [(ngModel)]="model.sortOrder" required />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="standard" style="font-size: medium;">Standard</label>
            </div>
            <div class="col-md-3">
                <p-listbox 
                    [options]="standardList" 
                    [(ngModel)]="model.standard" 
                    optionLabel="name" 
                    optionValue="id"
                    [style]="{'width':'15rem'}" 
                    [multiple]="true" 
                    [checkbox]="true" 
                    [filter]="true"
                    [listStyle]="{'max-height':'250px'}">
                </p-listbox>
            </div>

            <div class="col-md-1">
                <label for="glassBehaviour" style="font-size: medium;">Glass Behaviour</label>
            </div>
            <div class="col-md-3">
                <p-listbox 
                    [options]="glassBehaviourList" 
                    [(ngModel)]="model.glassBehaviour" 
                    optionLabel="name" 
                    optionValue="id"
                    [style]="{'width':'15rem'}" 
                    [multiple]="true" 
                    [checkbox]="true" 
                    [filter]="true"
                    [listStyle]="{'max-height':'250px'}">
                </p-listbox>
            </div>
        </div>
    </div>
    <div class="grid grid-nogutter d-flex justify-content-end">
        <button pButton pRipple label="{{'commonbtn.cancel'|translate}}" icon="pi pi-times" class="btn-cancle"
            (click)="cancel()"></button>
        &nbsp;
        <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
            (click)="save(model)"></button>
    </div>
</div>